export const PERMISSIONS_ERROR = 'PERMISSIONS_ERROR';